import React, { FunctionComponent } from 'react';
import { Typography, TTypographyProps } from '@rbx/ui';

export interface OpenCloudBasicTypeProps {
  type: string;
  variant?: TTypographyProps['variant'];
}

const OpenCloudBasicType: FunctionComponent<React.PropsWithChildren<OpenCloudBasicTypeProps>> = ({
  type,
  variant = 'code',
}) => {
  return (
    <Typography variant={variant} color='secondary'>
      {type === 'integer' ? 'number' : type}
    </Typography>
  );
};

export default OpenCloudBasicType;
